import _reduxForm from "redux-form/es/reduxForm";
import { connect } from 'react-redux';
import { createStructuredSelector, createSelector } from 'reselect';
import { ReduxFormNames } from 'swag-client-common/constants';
import { isEmailRequestToHubspotFormSubmitted } from '../../../../../redux/instant-quote/instant-quote.selectors';
import { sendEmailRequestToHubspot } from '../../../../../redux/instant-quote/instant-quote.actions';
import { emailFormComponent } from './email-form';
const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(sendEmailRequestToHubspot(data));
  }
});
const displayTextSelector = createSelector(isEmailRequestToHubspotFormSubmitted, isSubmitted => isSubmitted ? 'Thanks! Someone on our team will reach out shortly.' : 'Need some help finding the perfect product for your budget? Enter your email address and we will reach out.');
const mapStateToProps = createStructuredSelector({
  isSubmit: isEmailRequestToHubspotFormSubmitted,
  displayText: displayTextSelector
});
const Form = connect(mapStateToProps, mapDispatchToProps)(emailFormComponent);
export const EmailForm = _reduxForm({
  form: ReduxFormNames.InstantQuoteEmailForm,
  initialValues: {
    email: ''
  }
})(Form);